import React from 'react';
import { ManageProjectPermissionsUserSearchStyle as S } from './ManageProjectPermissionsUserSearch.style';
import { HStack } from 'components/layouts/primitives/Stack/Stack';
import { PButton } from 'components/prime/PButton/PButton';
import { Box } from 'components/layouts/primitives/Box/Box';
import { FormField } from 'components/FormField/FormField';
import { useManageProjectPermissionsModalBLoC } from 'components/modals/ManageProjectPermissionsModal/ManageProjectPermissionsModal.bloc';
import { useObservableState } from 'observable-hooks';
import { useFormValue } from 'hooks/useFormValue';

export const ManageProjectPermissionsUserSearch: React.FC = () => {
  const { form, $loading, $availableProjectUsers, addUserPermissionToProject } =
    useManageProjectPermissionsModalBLoC();
  const users = useFormValue(form, 'users');
  const availableProjectUsers = useObservableState($availableProjectUsers, []);
  const loading = useObservableState($loading);

  return (
    <FormField
      form={form}
      controller={{
        name: 'users',
      }}
      helpText="Email notification will be sent once added."
    >
      {({ field }) => (
        <HStack gap="gap2">
          <Box fit="space">
            <S.PMultiSelect
              maxSelectedLabels={1}
              selectedItemsLabel="{0} selected"
              placeholder="All users"
              options={availableProjectUsers || []}
              showClear
              value={field?.value || []}
              onChange={field.onChange}
              filter
              filterPlaceholder="Search"
              filterBy="name"
              optionValue="id"
              optionLabel="name"
              data-testid="input-manage-project-permissions-search"
            />
          </Box>
          <PButton
            severity="soft"
            label="Add to project"
            className="w-full"
            onClick={addUserPermissionToProject}
            disabled={!users?.length}
            loading={loading === 'addingUser'}
            data-testid="button-manage-project-permissions-add"
          />
        </HStack>
      )}
    </FormField>
  );
};
